<template>
    <div class="collect">
        <div class="flex__between search-box bb_1">
            <div class="flex align-center search__item">
                <span class="fs_28 c_b3 jcicon jcicon-sousuo1">&nbsp;</span>
                <input class="fs_28 c_b3" type="text" placeholder="请输入关键字搜索" v-model="loads.keyword">
            </div>
            <div class="flex align-center" v-show="!edit_switch" @click="edit_switch=!edit_switch">
                <span class="jcicon jcicon-bianji fs_32 c_1a"></span>
                <span class="fs_28 c_1a">&nbsp;编辑</span>
            </div>
            <div class="flex align-center" v-show="edit_switch" @click="edit_switch=!edit_switch">
                <span class="jcicon jcicon-chenggong- fs_32 c_1a"></span>
                <span class="fs_28 c_1a">&nbsp;完成</span>
            </div>
        </div>
        <!-- 列表 -->
        <div class="row-box">
            <div class="flex row__item" :class="edit_switch?'left_60':''" v-for="(item,index) in list" :key="index" @click="editOperate(index)">
                <div class="flex align-center checkbox__item" v-show="edit_switch">
                    <van-checkbox v-model="item.is_chose" checked-color="#F93A42"></van-checkbox>
                </div>
                <img :src="item.cover_img" alt="">
                <div class="flex__null__around row__info">
                    <div class="flex ellipsis_two">
                        <span v-if="item.is_invalid==2" class="invalid-box">失效</span>
                        <span class="fs_30 c_1a lh_40">{{item.name}}</span>
                    </div>
                    <div class="mt_10 lh_40">
                        <span class="fs_26 c_main">¥</span>
                        <span class="fs_36 c_main">{{item.price}}</span>
                    </div>
                </div>
            </div>
            <jc-list v-if="refresh" :url="'/Mall/getMyCollectList'" :loads="loads" @load='getList'></jc-list>
        </div>
        <!-- 底部操作栏 -->
        <div class="flex__between__center footer" v-show="edit_switch">
            <div class="flex__between__center footer__left">
                <van-checkbox v-model="is_all" checked-color="#F93A42" @click="setAll"></van-checkbox>
                <span class="fs_32 c_4d">&ensp;全选</span>
            </div>
            <div class="flex align-center">
                <span class="fs_32 c_main" @click="del">清空失效宝贝</span>
                <button class="cancel" @click="cancel">取消收藏</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'Collect',
    data(){
        return{
            refresh: true, //刷新组件用
            edit_switch: false,
            is_all: 0,
            list: [],
            loads: {
                user_id: localStorage.user_id,
                keyword:''
            }
        }
    },
    methods:{
        getList (data) { 
            this.list=data;
        },
        // 点击商品
        editOperate(index){
            if(this.edit_switch){
                this.list[index].is_chose=!this.list[index].is_chose;
            }else{
                this.$router.push('/Mall/Detail/'+item.product_id);
            }
        },
        // 全选
        setAll(){
            for(let i=0;i<this.list.length;i++){
                if(this.is_all){
                    this.list[i].is_chose=1;
                }else{
                    this.list[i].is_chose=0;
                }
            }
        },
        // 清楚失效的收藏
        del(){
            this.refresh=false;
            this.axios.post('/wechat.php/Mall/deleteCollectInvalid',{
                user_id: localStorage.user_id
            }).then(
                res=>{
                    this.refresh=true;
                    this.$toast(res.data.message);
                }
            )
        },
        // 取消收藏
        cancel(){
            this.refresh=false;
            let all_arr=[];
            let all_id='';
            for(let i=0;i<this.list.length;i++){
                if(this.list[i].is_chose==1){
                    all_arr.push(this.list[i].id);
                }
            }
            all_id=all_arr.join(',')
            this.axios.post('/wechat.php/Mall/deleteMyCollect',{
                user_id: localStorage.user_id,
                my_collect_id: all_id
            }).then(
                res=>{
                    this.refresh=true;
                    this.$toast(res.data.message);
                }
            )
        }
    },
    watch: {
        list:{
            handler(newVal, oldVal){
                let all_arr=[];
                if(newVal.length){
                    for(let i=0;i<newVal.length;i++){
                        if(newVal[i].is_chose){
                            all_arr.push(1);
                        }
                    }
                    if(all_arr.length==newVal.length){
                        this.is_all=1;
                    }else{
                        this.is_all=0;
                    }
                }else{
                    this.is_all=0;
                }
                
            },
            deep: true
        }
    }
}
</script>
<style scoped>
    .search__item{
        width: 580px!important;
    }
    .row-box{
        overflow: hidden;
        padding: 0 30px 130px;
        background: #fff;
    }
    .row__item{
        position: relative;
        margin-top: 30px;
    }
    .left_60{
        left: 60px;
    }
    .row__item img{
        width: 280px;
        height: 280px;
        border-radius: 10px;
    }
    .row__info{
        width: 420px;
        margin-left: 30px;
    }
    .invalid-box{
        height: 30px;
        padding: 0 12px;
        background: #cbcbcb;
        line-height: 30px;
        font-size: 22px;
        color: #fff;
        border-radius: 30px;
    }
    .checkbox__item{
        position: absolute;
        left: -60px;
        height: 280px;
    }
    /* footer */
    .footer{
        position: fixed;
        width: 100%;
        bottom: 0;
        height: 98px;
        background: #fff;
    }
    .footer__left{
        padding: 0 30px;
    }
    .cancel{
        width: 250px;
        height: 98px;
        margin-left: 30px;
        background: #F93A42;
        color: #fff;
        font-size: 32px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/mall/Collect.vue